export default {
  token: 'token',
  permissions: 'PERMISSIONS',
};
